import React from 'react';
import LoadingCenter from './LoadingCenter';

import Spinner from './Spinner';

const Button = ({ title, type, color, width, loading, onClick, styles }) => {

  const isFull = width === "full" ? "btn-xl" : "";
  const isLoading = loading ? "btn-opacity" : "";

  return (
    <button onClick={onClick} disabled={loading} type={type} className={`my-btn btn-${color} ${isFull} ${isLoading} ${styles}`}>
      {loading ? (
        <div style={{marginTop: "2px", marginBottom: "2px"}} className="spinner-center">
          <Spinner />
        </div>
      ):(
        title
      )}
    </button>
  );
}

export default Button;